import React from 'react';
import { cx } from "../../../../lib/theming/Emotion";
import { ThemeContext } from "../../../../lib/theming/ThemeContext";
import { InputLayoutContext } from "../InputLayoutContext";
import { stylesLayout } from "../InputLayout.styles";
export var InputLayoutAsideText = function InputLayoutAsideText(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? null : _ref$text;
  var theme = React.useContext(ThemeContext);
  var _React$useContext = React.useContext(InputLayoutContext),
    disabled = _React$useContext.disabled;
  var asideClassName = stylesLayout.aside();
  return text ? /*#__PURE__*/
  React.createElement("span", {
    className: cx(asideClassName, stylesLayout.text(theme), disabled && stylesLayout.textDisabled(theme))
  }, text) : null;
};